import React from "react";
import { useGlobalValue } from "../../state/GlobalProvider";
import RegularButton from "../inputs/RegularButton/RegularButton";
import styles from "./RawData.module.sass";
const RawData = props => {
  const {
    label,
    data
  } = props;
  const {
    pushModal
  } = useGlobalValue();
  if (!data) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["button"]} ${styles["raw-data"]}`
  }, /*#__PURE__*/React.createElement(RegularButton, {
    children: label,
    onClick: () => {
      pushModal({
        title: label,
        data: {
          data
        },
        args: "",
        view: "JsonViewer"
      });
    }
  }));
};
export default RawData;